import React from 'react';

const moods = ['😊', '😐', '😢', '😠', '😴'];

function MoodTracker({ mood, setMood }) {
  return (
    <div className="card">
      <h2>Mood Tracker</h2>
      <div className="mood-options">
        {moods.map((m, index) => (
          <span
            key={index}
            className={`mood ${mood === m ? 'selected' : ''}`}
            onClick={() => setMood(m)}
          >
            {m}
          </span>
        ))}
      </div>
      {mood && <p className="feedback">You selected: {mood}</p>}
    </div>
  );
}

export default MoodTracker;
